import React from "react";
import { useTranslation } from "react-i18next";

import { InfoPlate } from "fe-shared/src/components";
import { formatTransactionNumber } from "fe-shared-transactions/src/helpers/format";

import { InventoryAdjustmentDetails } from "../../../types/inventoryAdjustments";

import styles from "../InventoryAdjustmentsDetails.module.scss";
import InventoryAdjustmentStatusPlate from "../../../components/InventoryAdjustmentStatusPlate";
import AssigneeInventoryAdjustmentSelect from "../../../components/AssigneeInventoryAdjustmentSelect";

interface Props {
  canAssign?: boolean;
  inventoryAdjustment: InventoryAdjustmentDetails;
}

const InventoryAdjustmentStatus = ({
  canAssign,
  inventoryAdjustment,
}: Props) => {
  const { t } = useTranslation();
  const { assignee, overallAdjustmentNumber, statusCode } = inventoryAdjustment;
  const isAssigned = !!assignee?.userId;

  return (
    <div className={styles.header}>
      <div className={styles.status}>
        <InfoPlate variant="black" className={styles.statusInfoPlate}>
          {formatTransactionNumber(overallAdjustmentNumber)}
        </InfoPlate>
        <InventoryAdjustmentStatusPlate
          statusCode={statusCode}
          className={styles.statusInfoPlate}
        />
        <div className={styles.statusAssign}>
          {isAssigned && (
            <span className={styles.statusAssignLabel}>
              {t("transactions.details.assignedTo")}
            </span>
          )}
          <AssigneeInventoryAdjustmentSelect
            inventoryAdjustment={inventoryAdjustment}
            canAssign={canAssign}
            assigneeId={assignee?.userId}
            assigneeName={assignee?.displayName ?? undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default InventoryAdjustmentStatus;
